const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "2560px"
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`
};

export const maxDevice = {
  mobileS: `(max-width: ${size.mobileS - 1})`,
  mobileM: `(max-width: ${size.mobileM - 1})`,
  mobileL: `(max-width: ${size.mobileL - 1})`,
  tablet: `(max-width: ${size.tablet - 1})`,
  laptop: `(max-width: ${size.laptop - 1})`,
  laptopL: `(max-width: ${size.laptopL - 1})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`
};
